// OrdenDetalle.js
import React from "react";
import { Link } from "react-router-dom";

const OrderDetail = ({ orden }) => {
  const { id, data } = orden;

  return (
    <div>
      <h3>Orden ID: {id}</h3>
      <p>Total: ${data.total}</p>
      {/* Agrega más detalles según sea necesario */}
      <Link to={`/detalleOrden/${id}`}>Ver Detalles</Link>
      <hr />
    </div>
  );
};

export default OrderDetail;
